export default __webpack_public_path__ + "static/media/spin1.6f8ad3ee.png";